import React from 'react';
import errorImage from '../../assets/error/No Internet.gif'
import './error.css';
const Error = ({errMessage}) => (
  <div className="errorComponent">
    <img src={errorImage} alt="Loading..." />
    <p className='error'>Ooops!!! {errMessage}</p>
  </div>
);

export default Error;